import React from "react";
import PropTypes from "prop-types";
import {t} from "i18next";
import {CollapsibleDrawerContent} from "components/Drawer";
import css from "./ModuleSourceSection.module.scss";

const ModuleSourceSection = ({module, source}) => (
  <CollapsibleDrawerContent title={t("detection.drawer.sections.module.title")}>
    <table className={css.moduleTable}>
      <tbody>
        {module && (
          <tr>
            <td>{t("detection.drawer.sections.module.moduleLabel")}</td>
            <td>{module}</td>
          </tr>
        )}
        {source && (
          <tr>
            <td>{t("detection.drawer.sections.module.sourceLabel")}</td>
            <td>{source}</td>
          </tr>
        )}
      </tbody>
    </table>
  </CollapsibleDrawerContent>
);

ModuleSourceSection.propTypes = {
  module: PropTypes.string,
  source: PropTypes.string
};

export default ModuleSourceSection;
